<template>
    <div class="accordion" id="kbAccordion">
        <div class="accordion-item mb-3 border-0" v-for="(article,index) in articles" :key="article.id || index">
            <h2 class="accordion-header" :id="hdrId(index)">
                <button
                    class="accordion-button"
                    :class="{ collapsed: !isOpen(index) }"
                    type="button"
                    @click.prevent="toggle(index)"
                    :aria-expanded="isOpen(index) ? 'true' : 'false'"
                    :aria-controls="bodyId(index)"
                >
                    <div class="w-100">
                        <h4 class="mb-1">{{ article.title }}</h4>
                        <div class="kb-meta d-flex flex-wrap align-items-center small text-muted">
                                <span v-if="article.category" class="badge bg-light text-primary border">
                                    {{ article.category.name }}
                                </span>
                            <span v-if="displayLastUpdatedDate">{{ fmtDate(article.created_at) }}</span>
                        </div>
                        <div class="mt-3 d-flex flex-wrap gap-2" v-if="tags(article).length">
                            <span class="badge rounded-pill ml-2 kb-tag" v-for="(tag,tagIndex) in tags(article)" :key="tagIndex">#{{tag}}</span>
                        </div>
                    </div>
                </button>
            </h2>

            <div class="accordion-collapse collapse"
                 :id="bodyId(index)" :aria-labelledby="hdrId(index)">
                <div class="accordion-body p-4">
                    <div v-html="article.content"></div>
                </div>
            </div>
        </div>

        <div v-if="!isLoading && !articles.length" class="text-center text-muted py-4 border rounded">
            No articles found
        </div>
    </div>
</template>

<script>
export default {
    name: 'ArticlesComponent',
    props: {
        articles: {
            type: Array,
            default: () => []
        },
        displayLastUpdatedDate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            uid: 'kb-' + Math.random().toString(36).slice(2),
            openMap: {},
        };
    },
    watch: {
        articles() {
            this.openMap = {};
        },
    },
    methods: {
        toggle(i) {
            const el = document.getElementById(this.bodyId(i));
            if (!el || el.classList.contains('collapsing')) return;

            if (this.isOpen(i)) {
                this.hidePanel(i);
                this.$delete(this.openMap, i);
            } else {
                this.showPanel(i);
                this.$set(this.openMap, i, true);
            }
        },
        isOpen(i) {
            return !!this.openMap[i];
        },
        showPanel(i) {
            const el = document.getElementById(this.bodyId(i));
            if (!el || el.classList.contains('collapsing') || el.classList.contains('show')) return;

            el.classList.remove('collapse', 'show');
            el.classList.add('collapsing');
            el.style.height = '0px';
            void el.offsetHeight;
            el.style.height = el.scrollHeight + 'px';

            el.addEventListener('transitionend', () => {
                el.classList.remove('collapsing');
                el.classList.add('collapse', 'show');
                el.style.height = '';
            }, {once: true});
        },
        hidePanel(i) {
            const el = document.getElementById(this.bodyId(i));
            if (!el || el.classList.contains('collapsing') || !el.classList.contains('show')) return;

            el.style.height = el.scrollHeight + 'px';
            void el.offsetHeight;
            el.classList.remove('collapse', 'show');
            el.classList.add('collapsing');
            el.style.height = '0px';

            el.addEventListener('transitionend', () => {
                el.classList.remove('collapsing');
                el.classList.add('collapse');
                el.style.height = '';
            }, {once: true});
        },
        hdrId(i) {
            return `${this.uid}-hdr-${i}`;
        },
        bodyId(i) {
            return `${this.uid}-body-${i}`;
        },
        tags(a) {
            if (!a || !a.keywords) return [];
            return String(a.keywords).split(' ').map(s => s.trim()).filter(Boolean).slice(0, 5);
        },
        fmtDate(createdAt) {
            const date = new Date(createdAt);
            return date.toLocaleString('en-US', {
                month: 'long', day: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit', hour12: true,
            });
        }
    }
};
</script>
<style lang="scss">
.border {
    border: 1px solid #dee2e6 !important;
}

.rounded-pill {
    border-radius: 50rem !important;
}

.badge {
    display: inline-block;
    padding: .35rem .5rem;
    font-size: .75rem;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    border-radius: .375rem;
}

.accordion-item {
    border: 1px solid var(--acc-border);
    border-radius: .8rem;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .04);
}

.accordion-button {
    display: flex;
    align-items: center;
    width: 100%;
    padding: .9rem 1rem;
    font-size: 1rem;
    color: #212529;
    background: #fff !important;
    border: 0;
    cursor: pointer;
    transition: background-color .15s ease-in-out;
}

.accordion-button.collapsed {
    background: #fff;
}

.accordion-button:not(.collapsed) {
    background: #f7f8fa;
}

.accordion-button:focus {
    outline: 0;
}

.collapse:not(.show) {
    display: none;
}

.collapsing {
    height: 0;
    overflow: hidden;
    transition: height .35s ease;
}

@media (prefers-reduced-motion: reduce) {
    .collapsing {
        transition: none;
    }
}

.accordion-body {
    padding: 1rem;
    border-top: 1px solid #f0f2f5;
}

.kb-meta > span + span::before {
    content: "•";
    margin: 0 .5rem;
    color: #6c757d;
}

.kb-tag {
    background: #f8f9fa;
    color: #6c757d;
    border: 1px solid #e9ecef;
}
</style>
